import {App} from '../../constants/actionType';
import {ViewMode} from '../../constants/dataEnum';

const initialState = {
  prevViewMode: ViewMode.DASHBOARD,
  viewMode: ViewMode.DASHBOARD,
  version: '',

  errorBoundary: {
    hasError: false,
    error: null,
    info: null,
    isHandled: false,
  },
};

export default function appState(state = initialState, action = {}) {
  switch (action.type) {
    case App.CHANGE_VIEW:
      return {...state, prevViewMode: state.viewMode, viewMode: action.view};

    case App.SET_VERSION:
      return {...state, version: action.value};

    case App.SET_ERROR_BOUNDARY:
      return {
        ...state,
        errorBoundary: {
          hasError: action.hasError,
          error: action.error,
          info: action.info,
          isHandled: action.isHandled,
        },
      };

    default:
      return state;
  }
}
